export default "__VITE_ASSET__DAQ4VDtz__"